import { ref } from 'vue';
import { httpService } from '../services/httpService';
import { useSOCatalog } from './useSOCatalog';
import { log, error as logError } from '../utils/DebugLogger';

import '../contracts/AdditionalServices_ListaPorCategoriaResponse';
/**
 * Composable for SO Additional Services operations.
 * Wraps useSOCatalog('additional_services') + category-specific fetching.
 */
export function useSOAdditionalServices() {
  const catalog = useSOCatalog('additional_services');
  const isLoading = ref(false);
  const error = ref(null);
  const basePath = '/index.php/so/additional_services';

  /**
   * `franchiseId` opcional: com ele o backend responde o preço/prazo POR
   * FRANQUIA (so_additional_service_prices, migração E3) e esconde os
   * adicionais que a franquia desligou. Sem ele, os defaults globais — o
   * comportamento de sempre. O modal de adicionar item passa a franquia da OS.
   */
  const fetchByCategory = async (categoryId: number, franchiseId?: number) => {
    log('useSOAdditionalServices', 'fetchByCategory', 'Fetching by category', { categoryId, franchiseId });
    isLoading.value = true;
    error.value = null;
    try {
      const response = await httpService.get(`${basePath}/lista_por_categoria/${categoryId}`, {
        params: franchiseId ? { franchise_id: String(franchiseId) } : {},
        responseContract: 'AdditionalServices_ListaPorCategoriaResponse',
      });
      if (response.success) {
        return response.dados || [];
      }
      throw new Error(response.error || 'Erro ao buscar servicos adicionais por categoria');
    } catch (err) {
      logError('useSOAdditionalServices', 'fetchByCategory', 'Error', err);
      error.value = err.message;
      throw err;
    } finally {
      isLoading.value = false;
    }
  };

  return {
    ...catalog,
    isLoading,
    error,
    fetchByCategory
  };
}
